module.exports = __webpack_public_path__ + "static/media/x-2.f254e23e.svg";